export default '@media (max-width: 850px)';
